import { FormikValues } from 'formik';
import * as React from 'react';
import { useCallback, useMemo } from 'react';

import { countryList } from '../../../constants/countries';
import { ISelectorValue } from '../../../types/shell';
import { Selector } from './Selector';

interface IProps extends FormikValues {
  label?: string;
  error?: string | string[] | null | undefined;
  required?: boolean;
  value?: string;
  name?: string;
}

export const CountrySelector: React.FC<IProps> = ({ label, required, error, value, onChange, name }) => {
  const countryOptions = useMemo(() => {
    return countryList.map((country) => {
      return {
        value: country.two_digit_code,
        label: country.name,
      };
    });
  }, []);

  const handleChange = useCallback(
    (selectedValue: ISelectorValue) => {
      if (onChange) {
        onChange(name, selectedValue);
      }
    },
    [onChange, name],
  );

  const selectedCountry = useMemo(() => {
    return countryOptions.find((option) => option.value === value) || null;
  }, [value, countryOptions]);

  return (
    <Selector
      name={name}
      value={selectedCountry}
      onChange={(currentValue) => handleChange(currentValue as ISelectorValue)}
      options={countryOptions || []}
      required={required}
      error={error}
      dataAction="input_country"
      label={label}
      autoComplete={name}
    />
  );
};
